import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Logo_Technomac-snc_PNG.png")